import type { FC } from "react";
import { useBazaarVoice } from "../../hooks/use-bazaarvoice";

type BazaarWidgetProps = {
	type: "reviews" | "rating_summary" | "inline_rating";
	productSku: string;
};

export const BazaarWidget: FC<BazaarWidgetProps> = ({ type, productSku }) => {
	useBazaarVoice();

	const container = (
		<div id={type} data-bv-show={type} data-bv-product-id={productSku}></div>
	);

	if (type === "rating_summary") {
		return <div id="reviews">{container}</div>;
	}

	return container;
};

export default BazaarWidget;
